import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RequestModal as CreateRequestModal, ConfirmationModal as Discard } from "../../../common/modal/modal.component";
import { requestDetailsActions } from "../../../../store/external/request-reducer/request-details.reducer";
import { createRequestActions } from "../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "../../../../store/external/request-reducer/request-log.reducer";
import { withRouter } from "react-router-dom";

class CreateRequestDisplay extends Component {
    constructor(props) {
        super();
        this.CreateRequestModal = React.createRef();
    }

    componentDidMount() {
        const isUpdateForm = this.props.match.params.orderId > 0;

        this.props.setIsUpdateRequest(isUpdateForm);
        this.showModal();
    }

    showModal = () => {
        this.CreateRequestModal.current.handleShow();
    };
    
    resetUrl = () => {
        this.props.history.goBack();
    }

    render() {
        const { requestTypeId, requestType } = this.props.createRequest;
        let data = JSON.parse(sessionStorage.User).Employee;

        return (
            <div>
                <CreateRequestModal
                    id={"create-request-modal-" + requestTypeId}
                    closeAction={this.resetUrl}
                    ref={this.CreateRequestModal}
                    requestTypeId={requestTypeId}
                    requestType={requestType}
                    data={data}
                />
                <Discard title={"discard"} messageBody={"are you sure you want to discard?"} />
            </div>
        );
    }
}

export default withRouter(
    connect(
        state => {
            const { requestDetail, createRequest } = state;
            return {
                ...requestDetail
                , createRequest
            };
        },
        dispatch =>
            bindActionCreators(
                Object.assign({}, requestDetailsActions, createRequestActions, requestLogActions),
                dispatch
            )
    )(CreateRequestDisplay)
);
